const createFilterData = (filterValues=[], page=0, rowsPerPage=10) => {
  const data = {
    pageNo: page,
    pageSize: rowsPerPage,
  };

  const stringFilters = ['walletType', 'wallet_type', 'claim_status', 'is_kyc_active', 'is_active'];

  filterValues.forEach((filter) => {
    const { id, value } = filter;
    
    if (stringFilters.includes(id)) {
      data[id] = Array.isArray(value) ? value[0] : value;
      // Mirror claim_status to payment_status for backend compatibility
      if (id === 'claim_status') data['payment_status'] = data[id];
      if (id === 'payment_status') data['claim_status'] = data[id];
      // Mirror walletType to wallet_type just in case
      if (id === 'walletType') data['wallet_type'] = data[id];
      if (id === 'wallet_type') data['walletType'] = data[id];
    } else {
      data[id] = Array.isArray(value) ? value : [value];
    }
  });

  return data;
};

export default createFilterData;
